import { Content } from '@ay/bot';
import Bluebird from 'bluebird';
import { Message } from '../base/base.message';
import { MessageFactoryService } from '../message-factory.service';

export class MessageManagementMessage extends Message<Content.MessageManagement> {
  public type = 'message-management';

  public messages: Message<Content.Any>[] = [];

  public messageFactoryService: MessageFactoryService;

  public constructor() {
    super();
    this.content = new Content.MessageManagement(null, []);
  }

  public async loadFromContent(content: Content.MessageManagement) {
    this.content = content;
    this.messages = await Bluebird.map(content.content, (content) => {
      return this.messageFactoryService.createFromContent(content);
    });
  }

  public toString() {
    return this.content.name;
  }
}
